module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: 'https://us-central1-alitqan-fa631.cloudfunctions.net', 
    // API_URL: 'https://adminapi.yasalabs.cloud', //Local
    // API_URL: 'http://127.0.0.1:5001/alitqan-fa631/us-central1', //Local
    // STREAMING_URL: 'https://api.alitqan.ai', //Prod
    STREAMING_URL: 'https://dev.api.alitqan.ai', //Dev
    // STREAMING_URL: 'https://dev.api.alitqan.ai', 
    // STREAMING_URL: 'https://socket.yasalab.com', //Locals
    // SOCKET_URL: 'https://api.alitqan.ai',
    SOCKET_URL: 'https://dev.api.alitqan.ai',
    // SOCKET_URL: 'https://socket.yasalab.com',
    // ENVIRONMENT: 'Prod',
    ENVIRONMENT: 'Dev',
  }
};